// Preset fields use minutes.seconds; persisted values remain minutes.
export const parsePresetDuration = (value, maxMinutes) => {
  const match = String(value).trim().match(/^(\d+)(?:\.(\d{1,2}))?$/);
  if (!match) return NaN;
  const seconds = Number((match[2] || "").padEnd(2, "0"));
  const totalSeconds = Number(match[1]) * 60 + seconds;
  return seconds < 60 && totalSeconds > 0 && totalSeconds <= maxMinutes * 60
    ? totalSeconds / 60 : NaN;
};

export const presetDurationInput = (minutes) => {
  const seconds = Math.round(Number(minutes) * 60);
  const remainder = seconds % 60;
  return `${Math.floor(seconds / 60)}${remainder ? `.${String(remainder).padStart(2, "0")}` : ""}`;
};

export const formatPresetDuration = (minutes) => {
  const seconds = Math.round(Number(minutes) * 60);
  const remainder = seconds % 60;
  return remainder
    ? `${Math.floor(seconds / 60) ? `${Math.floor(seconds / 60)} min ` : ""}${remainder} sec`
    : `${Math.floor(seconds / 60)} min`;
};
